/* global axios */
import ApiClient from './ApiClient';

class DocumentTypesAPI extends ApiClient {
  constructor() {
    super('document_types', { accountScoped: true });
  }

  create(documentType) {
    return axios.post(this.url, { document_type: documentType });
  }

  update(id, documentType) {
    return axios.patch(`${this.url}/${id}`, { document_type: documentType });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new DocumentTypesAPI();
